import React from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import { pathPrefix } from 'gatsby-env-variables'

import { useIntl } from "gatsby-plugin-intl"

import Container from "../components/container/container"
import Navbar from "../components/navbar/navbar"
import Footer from "../components/footer/footer"
import Iframe from "../components/iframe/iframe";
import WBButton from "../components/wbbutton/wbbutton"

export default function Project({ data }) {
  const intl = useIntl()
  const posts = data.allMarkdownRemark.edges
  const filteredPost = posts.filter(singlePost => singlePost.node.frontmatter.lang === intl.locale);
  const post = filteredPost[0].node;
  const homeUrl = "/" + intl.locale;
  const moreProjectsText = intl.locale === 'nl' ? 'Meer projecten' : 'More projects';

  return (
    <React.Fragment>
      <Helmet>
        <title>Engineering: people's work | Witteveen+Bos</title>
      </Helmet>
      <Navbar />
      <Container>
          <h1>{post.frontmatter.title}</h1>
          <h2>{post.frontmatter.subtitle}</h2>

          { post.frontmatter.vrLink &&
            <WBButton 
              to={pathPrefix + "/vr/" + post.frontmatter.vrLink + "/index.html"}
              text="Experience in VR" 
              external={true}>
            </WBButton>
          }

          { post.frontmatter.vrLinkExtern1Url &&
            <WBButton 
              to={post.frontmatter.vrLinkExtern1Url} 
              text={post.frontmatter.vrLinkExtern1Title} 
              external={true}>
            </WBButton>
          }

          &nbsp;

          { post.frontmatter.vrLinkExtern2Url &&
            <WBButton 
              to={post.frontmatter.vrLinkExtern2Url} 
              text={post.frontmatter.vrLinkExtern2Title} 
              external={true}>
            </WBButton>
          }

          <div className="mt-5" dangerouslySetInnerHTML={{ __html: post.html }} />

          { post.frontmatter.iframeSrc &&
            <Iframe
              src={post.frontmatter.iframeSrc}
              title="InlineView"
              height="676px"
            />
          }

          <div className="my-5">
            <WBButton to={homeUrl} text={moreProjectsText}></WBButton>
          </div>
      </Container>
      <Footer />
    </React.Fragment>
  )
}

export const query = graphql`
query($slug: String!) {
  allMarkdownRemark(filter: { frontmatter: {slug: {eq: $slug }}}) {
    totalCount
    edges {
      node {
        html
        frontmatter {
          lang
          title
          subtitle
          vrLink
          vrLinkExtern1Url
          vrLinkExtern1Title
          vrLinkExtern2Url
          vrLinkExtern2Title
        }
      }
    }
  }
}
`